function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-949.000000, -215.000000)"
}, React.createElement("g", {
  transform: "translate(949.000000, 215.000000)"
}, React.createElement("g", null, React.createElement("circle", {
  stroke: "#484848",
  fillRule: "nonzero",
  cx: 8.5,
  cy: 8.5,
  r: 8
}), React.createElement("path", {
  d: "M5.34277344,6.41113281 C5.37451172,4.84960938 6.47900391,3.7578125 8.42773438,3.7578125 C10.2431641,3.7578125 11.4428711,4.76708984 11.4428711,6.21435547 C11.4428711,7.17285156 10.9794922,7.83935547 10.0844727,8.36621094 C9.24023438,8.85498047 9.00537109,9.16601562 9.00537109,9.78808594 L9.00537109,10.1245117 L7.32324219,10.1245117 L7.31054688,9.75634766 C7.22802734,8.75976562 7.57714844,8.18847656 8.453125,7.67431641 C9.27197266,7.18554688 9.51953125,6.87451172 9.51953125,6.27148438 C9.51953125,5.66845703 9.03710938,5.23046875 8.31347656,5.23046875 C7.58349609,5.23046875 7.10107422,5.69384766 7.06298828,6.41113281 L5.34277344,6.41113281 Z M8.18652344,13.1586914 C7.61523438,13.1586914 7.15185547,12.7207031 7.15185547,12.1621094 C7.15185547,11.6035156 7.61523438,11.1655273 8.18652344,11.1655273 C8.76416016,11.1655273 9.22753906,11.6035156 9.22753906,12.1621094 C9.22753906,12.7207031 8.76416016,13.1586914 8.18652344,13.1586914 Z",
  fill: "#484848"
})))));

const SvgHelpIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "17px",
  height: "17px",
  viewBox: "0 0 17 17",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgHelpIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/help-icon.be16a698.svg";
export { ForwardRef as ReactComponent };